import { useMemo } from 'react';
import { toDate } from 'lib/utils';
import { startOfDay, addDays } from 'date-fns';

interface Options {
  checkIn: string;
}

export const useStayDateRange = ({ checkIn }: Options) => {
  const checkInDate = useMemo(() => toDate(checkIn), [checkIn]);
  const minCheckInDate = useMemo(() => startOfDay(new Date()), []);
  const minCheckOutDate = useMemo(() => addDays(checkInDate, 1), [checkInDate]);
  const maxCheckOutDate = useMemo(() => addDays(checkInDate, 28), [checkInDate]);

  return { checkInDate, minCheckInDate, minCheckOutDate, maxCheckOutDate };
};
